import Button from "../../base/Button";

const renderIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
    >
        <g fill="none" fillRule="evenodd" stroke="#FFF">
            <path d="M12.5 5.552v19.034" />
            <path
                strokeLinecap="square"
                d="M19.948 17.138L12.5 24.586l-7.448-7.448M24.086 1.414H.914"
            />
        </g>
    </svg>
);

/**
 * Toolbar button for moving selected lights downward.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered move down button.
 */
const MoveDownButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default MoveDownButton;
